import { whyChoose } from '@/mocks/home';

export default function WhyChooseDomestic() {
  return (
    <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100" aria-labelledby="why-title">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 id="why-title" className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            为什么选择国产专区
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl mx-auto">
            我们致力于为消费者提供最专业、最值得信赖的国货推荐服务
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {whyChoose.map((item, index) => (
            <div key={index} className="bg-background-50 rounded-lg p-5 text-center">
              <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-100">
                <i className={`${item.icon} text-2xl text-primary-600`}></i>
              </div>
              <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}